import type { AxiosInstance } from 'axios';

import { appConfig } from '../../../../appConfig';
import axiosClientFactory from './clientFactory';

const getDirectGastrofyAxiosClient = (): AxiosInstance => {
    const client = axiosClientFactory.createDirectApiClient({
        baseURL: appConfig.coopSettings.ecommerce.gastrofyApiUrl,
        headers: {
            'X-Custom-Auth': appConfig.coopSettings.ecommerce.gastrofyApiKey,
            'X-Custom-User': appConfig.coopUserSettings.isAuthenticated
                ? appConfig.coopUserSettings.shoppingUserId
                : undefined,
        },
    });

    return client;
};

export default getDirectGastrofyAxiosClient;
